import { render, staticRenderFns } from "./BracketViewer.vue?vue&type=template&id=66888450&scoped=true"
import script from "./BracketViewer.vue?vue&type=script&lang=js"
export * from "./BracketViewer.vue?vue&type=script&lang=js"
import style0 from "./BracketViewer.vue?vue&type=style&index=0&id=66888450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66888450",
  null
  
)

export default component.exports